import { useRef, useEffect } from 'react';

const useSwipe = (ref: React.RefObject<HTMLElement>) => {
	const swipeLeft = useRef<(() => void) | null>(null);
	const swipeRight = useRef<(() => void) | null>(null);

	useEffect(() => {
		const currentRef = ref.current;
		const handleTouchStart = (e: TouchEvent) => {
			const touchX = e.touches[0].clientX;
			currentRef!['startX'] = touchX;
		};

		const handleTouchEnd = (e: TouchEvent) => {
			if (currentRef!['startX'] === undefined) return;

			const touchX = e.changedTouches[0].clientX;
			const diff = touchX - currentRef!['startX'];

			if (Math.abs(diff) > 50) {
				// Adjust sensitivity as needed
				if (diff > 0) {
					swipeRight.current && swipeRight.current();
				} else {
					swipeLeft.current && swipeLeft.current();
				}
			}

			delete currentRef!['startX'];
		};

		if (currentRef) {
			currentRef.addEventListener('touchstart', handleTouchStart);
			currentRef.addEventListener('touchend', handleTouchEnd);

			return () => {
				currentRef!.removeEventListener('touchstart', handleTouchStart);
				currentRef!.removeEventListener('touchend', handleTouchEnd);
			};
		} else {
			return () => {
				// do nothing
			};
		}
	}, [ref]);

	return { swipeLeft, swipeRight };
};

export default useSwipe;
